import { watch, ref } from "vue";
import { useGetProfileOptions, type Profile } from "@src/api";

const profile = ref<Profile | null>(null);

export const useProfileOptions = () => {
  const { execute, data, isLoading, isError, isSuccess } = useGetProfileOptions();

  watch(data, (newProfile) => {
    profile.value = newProfile;
  });

  const _hasPermission = (permissionName: string) => {
    if (!profile.value?.permissions) {
      return false;
    }

    return (
      profile.value.permissions.findIndex((permission) => permission.name === permissionName && permission.value) !== -1
    );
  };

  const hasPermission = (permission: string) => {
    if (_hasPermission("all")) {
      return true;
    }

    return _hasPermission(permission);
  };

  const hasLogin = () => {
    return _hasPermission("login");
  };

  const hasNeedRole = () => {
    return _hasPermission("need_role");
  };

  const permissionsIsEmpty = () => {
    return !profile.value || !profile.value.permissions || profile.value.permissions.length === 0;
  };

  const clearProfile = () => {
    profile.value = null;
  };

  const getRfidConstantValue = (key: keyof Profile["constants"]["rfid"], default_value?: number): number | null => {
    return profile.value.constants.rfid[key] || default_value || null;
  };

  return {
    getProfile: execute,
    profile,
    hasPermission,
    permissionsIsEmpty,
    clearProfile,
    hasLogin,
    hasNeedRole,
    isLoading,
    isError,
    isSuccess,
    getRfidConstantValue,
  };
};
